import { useEffect, useState } from "react";

import { formatDateTime } from "../lib/dateFormat";
import {
  DIAGNOSTIC_KIND_LABELS,
  DIAGNOSTIC_STAGE_LABELS,
  listTournamentDiagnostics,
  type DiagnosticListData,
} from "../lib/registrationDiagnostics";
import "./registrationDiagnostics.css";

/**
 * Inscripciones → «Intentos fallidos (últimos 7 días): N». Si una familia
 * dice que no pudo inscribirse, el organizador busca aquí su folio.
 */
export default function RegistrationDiagnosticsCard({ token, tournamentId }: { token: string; tournamentId: number }) {
  const [data, setData] = useState<DiagnosticListData | null>(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    let alive = true;
    listTournamentDiagnostics(token, tournamentId, 7)
      .then((response) => {
        if (alive) setData(response.data);
      })
      .catch(() => {
        // Si no carga, la tarjeta no se muestra: no estorba la pantalla.
        if (alive) setData(null);
      });
    return () => {
      alive = false;
    };
  }, [token, tournamentId]);

  if (!data) return null;

  return (
    <section className="card reg-diag reg-diag--card" aria-label="Intentos fallidos de inscripción">
      <div className="reg-diag__card-head">
        <div>
          <h3>Intentos fallidos (últimos 7 días): {data.total}</h3>
          <p className="muted">
            Envíos de inscripción que no se pudieron confirmar. La familia recibió un folio; búscalo aquí.
          </p>
        </div>
        {data.total > 0 ? (
          <button type="button" className="btn btn--compact btn--ghost" aria-expanded={open} onClick={() => setOpen((v) => !v)}>
            {open ? "Ocultar" : "Ver lista"}
          </button>
        ) : null}
      </div>
      {open && data.items.length > 0 ? (
        <ul className="reg-diag__list">
          {data.items.map((item) => (
            <li key={item.id} className="reg-diag__item">
              <div className="reg-diag__item-head">
                <strong className="reg-diag__folio-code">{item.folio}</strong>
                <span className={`reg-diag__pill reg-diag__pill--${item.error_kind}`}>
                  {DIAGNOSTIC_KIND_LABELS[item.error_kind] ?? item.error_kind}
                </span>
                <span className="muted">{formatDateTime(item.created_at)}</span>
              </div>
              <p className="muted reg-diag__version">
                {DIAGNOSTIC_STAGE_LABELS[item.stage] ?? item.stage}
                {item.http_status ? ` · código ${item.http_status}` : ""}
                {item.online === false ? " · sin internet" : ""}
              </p>
            </li>
          ))}
        </ul>
      ) : null}
    </section>
  );
}
